import React from 'react'
import WorkflowSourceType from '../../../../../commonComponents/WorkflowSourceTypeComponent/WorkflowSourceType'

const SessionData = ({ connectionDetails, handleBodyContent }) => {
    const valuesHandler = (data) => {
        handleBodyContent({ add: { ...data } });
    }
    return (
        <WorkflowSourceType
            node={{
                key: "sessionData",
                RECORD_TYPE: "SESSION_DATA",
                MAPNAME: connectionDetails?.FIELD_NAME,
                OUTBOUND_NAME: connectionDetails?.OUTBOUND_CONDITION,
                WFITEM: connectionDetails?.WF_ITEM,
                WF_ITEM_ID: connectionDetails?.WF_ITEM_ID
            }}
            valuesHandler={(values) => {
                valuesHandler({
                    ADAPTER_TYPE: "SESSION DATA",
                    FIELD_NAME: values?.MAPNAME,
                    OUTBOUND_CONDITION: values?.OUTBOUND_NAME,
                    WF_ITEM: values?.WFITEM,
                    WF_ITEM_ID: values?.WF_ITEM_ID
                });
            }}
            onlySessionData={true}
        />
    )
}

export default SessionData
